<!-- .cell-box envuelve cualquier tipo para que [maxWidth] funcione en todos: un ng-container no es un elemento y
     no admite estilos, y un <span> en línea ignora max-width -->
<span *ngIf="!isEmpty" class="cell-box" [style.max-width.px]="maxWidth" [ngSwitch]="type">
    <span *ngSwitchCase="'ref'" class="cell-ref">{{ value }}</span>
    <span *ngSwitchCase="'texto'" class="cell-texto">{{ value }}</span>
    <ng-container *ngSwitchCase="'fecha'">{{ dateValue | date:'dd/MM/yyyy' }}</ng-container>
    <span *ngSwitchCase="'importe'" class="cell-importe" [class.cell-importe--cero]="numberValue === 0">{{ numberValue | number:'1.2-2' }}<span class="cell-unidad">€</span></span>
    <ng-container *ngSwitchCase="'unidad'">{{ value }}<span class="cell-unidad">{{ unit }}</span></ng-container>
    <ng-container *ngSwitchCase="'porcentaje'">{{ numberValue | number:'1.2-2' }} %</ng-container>
    <ng-container *ngSwitchCase="'bool'">
        <span *ngIf="boolValue === true" class="cell-bool cell-bool--si">Sí</span>
        <span *ngIf="boolValue === false" class="cell-bool cell-bool--no">No</span>
        <ng-container *ngIf="boolValue === null">{{ value }}</ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>{{ value }}</ng-container>
</span>
